module.exports = __webpack_public_path__ + "static/img/pro11_tab1.9bb00b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/advertisement/introduceFour/pro11_tab1.jpg
// module id = RDcQ
// module chunks = 171